import { toast } from "../views/utilities/MyCustomFile";
import axios from "axios";
import { baseURLs } from 'views/axios/baseURL';
import { DealerNodes, ResellerNodes } from "./permissionFile";

export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

export const FETCH_PERMISSION = '@permission/FETCH_PERMISSION';
export const SET_PERMISSION = '@permission/SET_PERMISSION';

export const FETCH_DETAIL = '@user/FETCH_DETAIL';
export const LOGIN_SUCCESS = '@user/LOGIN_SUCCESS';

export function loginWithEmailAndPassword(userData) {
  const { email, email_otp, url, navigate, redirect = '/dashboard', success = '' } = userData;

  return (dispatch) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        dispatch({ type: FETCH_DETAIL });
        resolve(
          axios.post(`${baseURLs()}${url}`, { email, email_otp }, { withCredentials: false }) // keep CORS simple
            .then((response) => {
              const { status, token, side_nav, nodePerm, permission, message, permFlag, obj } = response.data ?? {};
              if (status) {
                // Persist token and set default Authorization header for future requests
                if (token) {
                  sessionStorage.setItem('token', token);
                  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                }

                if (success) toast.success(success);
                navigate(redirect);

                return dispatch({
                  type: LOGIN_SUCCESS,
                  data: {
                    message: "",
                    sidenav: side_nav,
                    nodes: nodePerm,
                    permission,
                    permFlag,
                    obj
                  }
                });
              } else {
                toast.error(message || 'Login failed');
              }
            })
            .catch((error) => {
              const status = error?.response?.status;
              const msg = error?.response?.data?.message || error?.message || 'Request failed';
              if (status === 400 || status === 401 || status === 403) {
                toast.error(msg);
              } else {
                toast.error(msg);
                navigate('/login');
              }
            })
        );
      }, 200);
    });
  };
}

export function fetchRoleBasePermission(role_id) {
  return (dispatch) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        dispatch({ type: FETCH_PERMISSION });
        resolve(
          dispatch({
            type: SET_PERMISSION,
            data: {
              nodes: role_id === 2 ? DealerNodes : ResellerNodes
            }
          })
        );
      }, 200);
    });
  };
}


// import { toast } from "../views/utilities/MyCustomFile"
// import axios from "axios";
// import { baseURLs } from 'views/axios/baseURL';
// import { DealerNodes, ResellerNodes } from "./permissionFile"
// // action - customization reducer
// export const SET_MENU = '@customization/SET_MENU';
// export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
// export const MENU_OPEN = '@customization/MENU_OPEN';
// export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
// export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

// export const FETCH_PERMISSION = '@permission/FETCH_PERMISSION';
// export const SET_PERMISSION = '@permission/SET_PERMISSION';

// export const FETCH_DETAIL = '@user/FETCH_DETAIL';
// export const LOGIN_SUCCESS = '@user/LOGIN_SUCCESS';

// export function loginWithEmailAndPassword(userData) {
//     const { email, email_otp, url, navigate } = userData
//     return (dispatch) => {
//         return new Promise(resolve => {
//             setTimeout(() => {
//                 dispatch({ type: FETCH_DETAIL });
//                 resolve(axios
//                     .post(`${baseURLs()}${url}`, { email, email_otp })
//                     .then((response) => {
//                         const { status, token, side_nav, nodePerm, permission, message, permFlag, obj } = response.data ?? {}
//                         if (status) {
//                             navigate("/dashboard")
//                             sessionStorage.setItem("token", token)
//                             return dispatch({
//                                 type: LOGIN_SUCCESS,
//                                 data: {
//                                     message: "",
//                                     sidenav: side_nav,
//                                     nodes: nodePerm,
//                                     permission, permFlag, obj
//                                 }
//                             })
//                         } else { toast.error(message) }
//                     })
//                     .catch((error) => {
//                         if (error.response.status === 400) {
//                             toast.error(error.response.data.message)
//                         } else {
//                             toast.error(error.message)
//                             navigate("/login")
//                         }
//                     })
//                 )
//             }, 500)
//         })
//     }
// }

// export function fetchRoleBasePermission(role_id) {
//     return (dispatch) => {
//         return new Promise(resolve => {
//             setTimeout(() => {
//                 dispatch({ type: FETCH_PERMISSION });
//                 resolve(dispatch({
//                     type: SET_PERMISSION,
//                     data: {
//                         nodes: role_id === 2 ? DealerNodes : ResellerNodes
//                     }
//                 }))
//             }, 500)
//         })
//     }
// }